import { gql } from '@apollo/client';

/**
 * Instance GraphQL Fragment — all exposed fields
 *
 * Skipped fields (not available in GQL):
 *   tenantId, correlationId, createdBy — #[graphql(skip)]
 *   formulaInstanceIds — #[graphql(skip)]
 */
export const INSTANCE_FIELDS_FRAGMENT = gql`
  fragment InstanceFields on Instance {
    # Identity & Context (4 fields — tenantId/correlationId/createdBy skipped)
    id
    parentId
    rootInstanceId
    workflowDefinitionId
    instanceName

    # Execution State (8 fields)
    status
    currentState
    previousState
    startedAt
    completedAt
    pausedAt
    resumedAt
    durationMs

    # Input/Output Data (4 fields)
    inputData
    outputData
    contextVariables
    accumulatedResults

    # Progress Tracking (6 fields)
    totalTasks
    completedTasks
    failedTasks
    progressPercent
    currentMilestone
    milestonesCompleted

    # Event-Driven Integration (5 fields)
    eventCount
    lastEventId
    lastEventType
    lastEventAt
    activeSubscriptions

    # Error Handling & Recovery (5 fields)
    errorMessage
    errorCode
    errorDetails
    failedTaskId
    recoveryAttempts

    # Performance & Monitoring (8 fields)
    engineType
    engineVersion
    cpuTimeMs
    memoryPeakMb
    dbQueries
    cacheHits
    cacheMisses
    estimatedCostUsd

    # Lifecycle & Audit (10 fields — createdBy skipped)
    createdAt
    updatedAt
    version
    metadata
    tags
    priority
    timeoutMs
    deadline
    scheduledStartTime
    maxRetries

    # Lifecycle — DRR-140/141 (2 fields)
    constellationRef
    subjectActorId

    # Formula Compression (2 fields — formulaInstanceIds skipped)
    formulaNumber
    formulaAutoDetected

    # Soft Delete (1 field)
    isActive

    # Complex Object Resolvers (6 fields)
    compressedId
    createdByActor {
      id
      displayName
      role
    }
    workflowName
    workflowDescription
    subjectName
    availableTransitions {
      event
      targetState
      guards
    }
  }
`;
